<template>
	<div class="PC-versioning">
		<el-dialog :title="choosedItem" :visible.sync="loadingDialog" :close-on-click-modal="false" :before-close="closeLoading">
			<div class="loading" v-if="showLoading">
				<p>正在上传中，请耐心等待。。。</p>
				<el-progress  type="circle" :percentage="fileUploadPercent" style="margin-top:30px;"/>
			</div>
			<div v-else class="upload-succ">
				上传成功啦！
			</div>
		</el-dialog>
		<div class="PC-versioning-left">
			<Tree :showSwitch="false" title=' ' @nodeClick="nodeClick"></Tree>
		</div>
		<div class="PC-versioning-right " style="overflow: auto">
			<div class="BOX PC" :key="inx" v-for="(item,inx) in list">
				<div class="topBOX">
					<i style="font-size: 30px" v-if="item.appType=='PC'" class="iconfont iconPC1"></i>
					<i style="font-size: 30px" v-if="item.appType=='STB'" class="iconfont iconjidinghe"></i>
          <i style="font-size: 30px" v-if="item.appType=='IOS'" class="iconfont iconIOS"></i>
					<i style="font-size: 30px" v-if="item.appType=='ANDROIDH'" class="iconfont iconjidinghe"></i>
					<i style="font-size: 30px" v-if="item.appType=='ANDROID'" class="iconfont iconanzhuo"></i>
					<p v-if="item.appType=='PC'">Computer</p>
					<p v-if="item.appType=='STB'">机顶盒</p>
          <p v-if="item.appType=='IOS'">IOS</p>
					<p v-if="item.appType=='ANDROIDH'">横版Android</p>
					<p v-if="item.appType=='ANDROID'">Android</p>
				</div>
				<div class="details">
					<div class="content">
						<el-form :model="ruleForm[inx]" :ref="'ruleForm'+inx" label-width="100px" class="demo-ruleForm">

							<el-form-item label="当前版本" prop="currentVersion" :rules="[{ required: true, message: '请输入当前版本', trigger: 'blur' }, ]">
								<el-input style="width: 80%" placeholder="请输入当前版本" v-model="ruleForm[inx].currentVersion"></el-input>
							</el-form-item>
							<el-form-item label="最低版本" prop="minVersion" :rules="[{ required: true, message: '请输入最低版本', trigger: 'blur' }, ]">
								<el-input style="width: 80%" placeholder="请输入最低版本" v-model="ruleForm[inx].minVersion"></el-input>
							</el-form-item>
							<el-form-item label="地    址" prop="url" :rules="[{ required: true, message: '请上传url地址', trigger: 'blur' }]">
								<el-upload class="upload-demo" :multiple="false" :show-file-list="false" :with-credentials="true" ref="upload"
								 accept=".apk,.opa,exe,.zip" :action="uploadFile" :before-upload="beforeUpload" :on-success="uploadSuccess"
								 :on-progress="uploadFileProcess" :on-error="uploaderror">
									<div style="width: 80%;display: flex;">
										<el-input style="flex: 1;" slot="trigger" placeholder="请上传url地址" v-model="ruleForm[inx].url"></el-input>
										<el-button @click="clickInx(inx,item)" slot="trigger" :loading="loadingInx[inx]" size="small" type="primary">选取文件</el-button>
									</div>
								</el-upload>
							</el-form-item>
							<el-form-item label="描    述" prop="description">
								<el-input style="width: 80%" type="textarea" resize="none" placeholder="请输入描述" maxlength="30" show-word-limit v-model="ruleForm[inx].description"></el-input>
							</el-form-item>
							<div class="" style="text-align: center">
								<el-button type="primary" @click="save('ruleForm'+inx,inx)">保存</el-button>
							</div>
						</el-form>

					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import publicAPI from "../../../../api-path/public-api";
	import {
		setSystemApi
	} from "../../../../api-path/district-api";
	import Tree from "../../../../components/Tree/nodeTree";
	// import Button from "../../../../components/Button/Button";

	export default {
		name: "PC-versioning",
		components: {
			// Button,
			Tree
		},
		data() {
			return {
				loading: false,
				index: null,
				uploadFile: publicAPI.uploadFile,
				ruleForm: [],
				list: [],
				loadingInx: [],
				fileUploadPercent:0,
				showLoading:false,
				loadingDialog:false,
				choosedItem:'',
			}
		},
		created() {

		},
		methods: {
			clickInx(inx,item) {
				this.index = inx;
				switch(item.appType){
					case 'PC':this.choosedItem='Computer文件上传';break;
					case 'STB':this.choosedItem='机顶盒文件上传';break;
          case 'IOS':this.choosedItem='IOS文件上传';break;
					case 'AndroidH':this.choosedItem='andridH文件上传';break;
					case 'Android':this.choosedItem='Android文件上传';break;
				}
			},
			nodeClick(node) {
				this.areaId = node.id;
				console.log(111)
				this.getPCVersions()
			},
			getPCVersions() {
				this.loading = true;
				this.$http.get(setSystemApi.queryList, {
					params: {
						areaId: this.areaId
					}
				}).then(res => {
					this.loading = false;
					if (res.status == 200) {
						this.list = res.result;
						this.ruleForm = [];
						res.result.forEach((item) => {
							this.loadingInx.push(false)
							this.ruleForm.push({
								id: item.id,
								currentVersion: item.currentVersion,
								minVersion: item.minVersion,
								url: item.url,
								description: item.description,
							})

						})

					}
				})
			},
			beforeUpload() {
				this.loadingInx[this.index] = true;
				this.showLoading=true;
				this.loadingDialog=true;
			},
			uploadFileProcess(event, file, fileList){
				this.fileUploadPercent=Number(file.percentage.toFixed());
			},
			closeLoading(){
				if(this.showLoading==false){
					this.loadingDialog=false;
					this.choosedItem='';
				}
			},
			save(formName, inx) {
				console.log(this.$refs[formName]);
				this.ruleForm[inx].areaId = this.areaId;
				this.ruleForm[inx].appType = this.list[inx].appType;
				this.$refs[formName][0].validate((valid) => {
					if (valid) {
						this.$http.post(setSystemApi.saveQueryList, this.ruleForm[inx]).then(res => {
							if (res.status == 200) {
								this.$message.success('保存成功')
								this.getPCVersions()
							}else{
								this.$message.error(res.result)
							}
						})
					} else {
						return false;
					}
				});

			},
			uploadSuccess(res) {
				this.loadingInx[this.index] = false;
				this.fileUploadPercent=0;
				this.showLoading=false;
				this.ruleForm[this.index].url = res.result.url;
			},
			uploaderror() {
				this.$message.error('上传失败，请重试');
				this.loadingDialog=false;
				this.showLoading=false;
				this.loadingInx[this.index] = false;
				this.choosedItem='';
			},
			//壳子回调
			QCefClientEvent(event){
			  if(typeof event == 'undefined')
			    return;
			
			  if(event["isScucess"]) {
				this.loadingInx[this.index] = false;
				  this.ruleForm[this.index].url = res.result.url;
			    this.message.success('上传成功');
			  }else {
			    this.message.error('上传失败');
			  }
			},
			//上传调用壳子选择文件
			handleupload(){
				let data={};
				const $this=this;
				let eventName = "QCefClient_PC";
				QCefClient.addEventListener(eventName, $this.QCefClientEvent);
				data.objeType = this.index;
				data.eventName = '';
				const jsons = JSON.stringify(data);
				QCefClient.invokeMethod('QCef_Open_Upload', jsons);
			}
		}
	}
</script>

<style lang="less">
	.PC-versioning {
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		padding: 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;
		.loading{
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column
		}
		.PC-versioning-left {
			margin-right: 10px;
			border-right: 1px solid #c1c1c1;

			.plug-tree {}
		}

		.PC-versioning-right {
			flex: 1;

			.BOX {
				display: inline-block;
				width: 40%;
				margin-left: 7%;
				border-radius: 10px;
				margin-bottom: 20px;
				/*height: 500px;*/
				overflow: hidden;

				.topBOX {
					height: 200px;
					background: #00a0e9;
					color: #fff;
					text-align: center;
					font-size: 22px;
					padding: 60px;
					box-sizing: border-box;

					p {
						font-weight: bolder;
					}
				}

				.details {
					background: rgba(70, 103, 212, 0.1);
					padding: 10px;

					.content {
						padding: 10px;
						background: #fff;
						height: 280px;
						.upload-demo{
							.el-upload {
								width: 100%;
							}
						}

					}
				}

			}

		}
	}
</style>
